import { render, staticRenderFns } from "./trainingCourse.vue?vue&type=template&id=39eb4d5a&scoped=true&name=trainingCourse&"
import script from "./trainingCourse.vue?vue&type=script&lang=js&"
export * from "./trainingCourse.vue?vue&type=script&lang=js&"
import style0 from "./trainingCourse.vue?vue&type=style&index=0&id=39eb4d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb4d5a",
  null
  
)

export default component.exports